'use strict';

import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { findDOMNode } from 'react-dom';
import classNames from 'classnames';

import { Popup } from '../Popup';
import ToggleSwitch from './ToggleSwitch';
import { fixedPrice } from '../../utils/formater';

class PriceRange extends PureComponent {
  constructor (props) {
    super(props);

    this.state = {
      opened: false,
      priceMin: props.priceMin,
      priceMax: props.priceMax,
      priceUnitId: props.priceUnitId,

      prevMin: props.priceMin,
      prevMax: props.priceMax,
      prevUnitId: props.priceUnitId
    };

    this.placeholder = props.placeholder;
    this.changed = false;
    this.listened = false;

    this.refPopupContainer = React.createRef();

    this.getLabel = this.getLabel.bind(this);
    this.setMinPrice = this.setMinPrice.bind(this);
    this.setMaxPrice = this.setMaxPrice.bind(this);
    this.setToggle = this.setToggle.bind(this);
    this.renderMenu = this.renderMenu.bind(this);
    this.handleOpenPopup = this.handleOpenPopup.bind(this);
    this.handleClickOutside = this.handleClickOutside.bind(this);
    this.handlerFocusInput = this.handlerFocusInput.bind(this);
  }

  parseValue (number) {
    return isNaN(parseInt(number)) ? null : parseInt(number);
  }

  isEmpty () {
    return !this.state.priceMin && !this.state.priceMax;
  }

  setMinPrice (e) {
    if (e.target.value.length > 10) {
      return;
    }

    const priceMin = this.parseValue(e.target.value);

    this.changed = true;
    this.setState({ priceMin }, () => {
      this.props.fireUpdate && this.props.onUpdate({ priceMin });
    });
  }

  setMaxPrice (e) {
    if (e.target.value.length > 10) {
      return;
    }

    const priceMax = this.parseValue(e.target.value);

    this.changed = true;
    this.setState({ priceMax }, () => {
      this.props.fireUpdate && this.props.onUpdate({ priceMax });
    });
  }

  setToggle (state) {
    const priceUnitId = state ? 2 : null;
    this.changed = true;
    this.setState({ priceUnitId }, () => {
      this.props.fireUpdate && this.props.toggleEnable && this.props.onUpdate({priceUnitId});
    });
  }

  getLabel () {
    const minPrice = this.state.priceMin;
    const maxPrice = this.state.priceMax;

    if (minPrice && maxPrice) {
      return [minPrice, maxPrice]
        .filter(Boolean)
        .map(number => fixedPrice(number))
        .join(' - ');
    }

    if (minPrice) {
      return `от ${fixedPrice(minPrice)}`;
    }

    if (maxPrice) {
      return `до ${fixedPrice(maxPrice)}`;
    }

    return this.placeholder;
  }

  static getDerivedStateFromProps (props, state) {
    const state_ = {};

    if (props.priceMin !== state.prevMin) {
      state_.prevMin = props.priceMin;
      state_.priceMin = props.priceMin;
    }

    if (props.priceMax !== state.prevMax) {
      state_.prevMax = props.priceMax;
      state_.priceMax = props.priceMax;
    }

    if (props.priceUnitId !== state.prevUnitId) {
      state_.prevUnitId = props.priceUnitId;
      state_.priceUnitId = props.priceUnitId;
    }

    return state_;
  }

  componentDidUpdate (prevProps, prevState) {
    if (this.state.opened && !this.listened) {
      this.listened = true;
      document.addEventListener('click', this.handleClickOutside);
    } else if (!this.state.opened && this.listened) {
      this.listened = false;
      document.removeEventListener('click', this.handleClickOutside);
    }
  }

  componentWillUnmount () {
    this.listened && document.removeEventListener('click', this.handleClickOutside);
  }

  handleClickOutside (e) {
    const nodeRef = findDOMNode(this.refPopupContainer.current);
    const { opened } = this.state;

    if (nodeRef && nodeRef !== e.target && !nodeRef.contains(e.target) && opened) {
      this.handlerClosePopup();
    }
  }

  handlerClosePopup () {
    const { priceMin, priceMax, priceUnitId } = this.state;
    const toggleEnable = this.props.toggleEnable;

    this.setState({ opened: false });

    if (this.changed) {
      this.changed = false;
      this.props.onUpdate({
        priceMin: priceMin || null,
        priceMax: priceMax || null,
        priceUnitId: toggleEnable ? ((priceMin || priceMax) ? priceUnitId : null) : null
      });
    }
  }

  handleOpenPopup (e) {
    e.preventDefault();

    this.setState({
      opened: !this.state.opened
    });
  }

  handlerFocusInput (e) {
    e.target.select();
  }

  renderMenu () {
    return (
      <Popup
        opened={this.state.opened} direction='bottom-left'
        mainOffset={0} secondaryOffset={0} ref={this.refPopupContainer}
      >
        <div className='pricerange-control-panel'>
          <div>
            <span className='title'><i>!</i>Цена указывается в рублях</span>
            <div className='input-item'>
              <input
                autoFocus
                onFocus={this.handlerFocusInput}
                value={this.state.priceMin || ''}
                placeholder='От' type='text'
                onKeyUp={e => e.keyCode === 13 && this.handlerClosePopup()}
                onChange={this.setMinPrice} />
            </div>
            <div className='input-item'>
              <input
                onFocus={this.handlerFocusInput}
                value={this.state.priceMax || ''}
                placeholder='До' type='text'
                onKeyUp={e => e.keyCode === 13 && this.handlerClosePopup()}
                onChange={this.setMaxPrice} />
            </div>
          </div>

          {
            this.props.toggleEnable &&
            <ToggleSwitch
              labelOn={this.props.labelToggleOn}
              labelOff={this.props.labelToggleOff}
              onToggle={this.setToggle}
              enabled={!!this.state.priceUnitId}
            />
          }
        </div>

      </Popup>
    );
  }

  render () {
    const arrowClass = classNames(
      'button-select-value', 'button-flat', {
        'down': !this.state.opened,
        'up': this.state.opened
      });

    const textClass = classNames({
      'placeholder': this.isEmpty()
    });

    return (
      <div className='pricerange-control-box'>
        <div className='pricerange-control-value' onClick={this.handleOpenPopup}>
          <button className={arrowClass} type='button'>
            <span className={textClass}>{this.getLabel()}</span>
          </button>

          {this.state.opened && this.renderMenu()}
        </div>
      </div>
    );
  }
}

PriceRange.propTypes = {
  priceMin: PropTypes.number,
  priceMax: PropTypes.number,
  priceUnitId: PropTypes.number,

  toggleEnable: PropTypes.bool,
  labelToggleOn: PropTypes.string,
  labelToggleOff: PropTypes.string,

  placeholder: PropTypes.string,
  fireUpdate: PropTypes.bool,
  onUpdate: PropTypes.func.isRequired                     // callback({name: value, ..., nameN: valueN})
};
PriceRange.defaultProps = {
  priceMin: null,
  priceMax: null,

  toggleEnable: false,
  labelToggleOn: 'Цена за м2',
  labelToggleOff: 'Цена общая',

  priceUnitId: null,
  placeholder: 'Цена',
  fireUpdate: false
};

export default PriceRange;



// WEBPACK FOOTER //
// ./src/ui/Controls/PriceRange.jsx